import React, { useState, useEffect } from 'react';
import Slider from "react-slick";
import full_img_slider from "../../../assets/images/full_img_slider.png"
import full_img_slider2 from "../../../assets/images/full_img_slider2.png"
import full_img_slider3 from "../../../assets/images/full_img_slider3.png"
import full_img_slider4 from "../../../assets/images/full_img_slider4.png"

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Slider_listing() {
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const [slider1, setSlider1] = useState(null);
    const [slider2, setSlider2] = useState(null);

    useEffect(() => {
        setNav1(slider1);
        setNav2(slider2);

    });
    const settingsMain = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.slider-nav'
    };

    const settingsThumbs = {
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        centerMode: true,
        swipeToSlide: true,
        focusOnSelect: true,
        centerPadding: '0px',
        margin: 70,
    };

    const slidesData = [
        {
            id: 1,
            title: 'College Campus',
            label: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas consectetur maximus est, vel tincidunt odio auctor nec. Nam sed sollicitudin sapien..',
            image: full_img_slider,
        }, {
            id: 2,
            title: 'College Campus2',
            label: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas consectetur maximus est, vel tincidunt odio auctor nec. Nam sed sollicitudin sapien..',
            image: full_img_slider2
        }, {
            id: 3,
            title: 'College Campus3',
            label: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas consectetur maximus est, vel tincidunt odio auctor nec. Nam sed sollicitudin sapien..',
            image: full_img_slider3
        }, {
            id: 4,
            title: 'College Campus4',
            label: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas consectetur maximus est, vel tincidunt odio auctor nec. Nam sed sollicitudin sapien..',
            image: full_img_slider4
        }
    ];

    return (
        <div className="slider_detail">
            <div className="slider-wrapper">
                <Slider
                    {...settingsMain}
                    asNavFor={nav2}
                    ref={slider => (setSlider1(slider))} >
                    {slidesData.map((slide) =>
                        <div className="slick-slide" key={slide.id}>
                            <h2 className="slick-slide-title">{slide.title}</h2>
                            <img className="slick-slide-image" src={slide.image} />
                            <icon class="fas fa-bookmark" />
                            <label className="slick-slide-label">{slide.label}</label>
                        </div>
                    )}

                </Slider>
                <div className="thumbnail-slider-wrap">
                    <Slider
                        {...settingsThumbs}
                        asNavFor={nav1}
                        ref={slider => (setSlider2(slider))}>

                        {slidesData.map((slide) =>
                            <div className="slick-slide" key={slide.id}>
                                <img className="slick-slide-image" src={slide.image} />
                            </div>
                        )}
                    </Slider>
                </div>
            </div>
        </div>
    );
}

export default Slider_listing;
